import debounce from 'lodash/debounce';

export function reloadOTSettingsButton() {
  if (window.OneTrust) {
    setTimeout(() => {
      const settingsButtons = document.querySelectorAll('.ot-sdk-show-settings');

      settingsButtons.forEach((button) => {
        // eslint-disable-next-line no-param-reassign
        button.onclick = (event) => {
          event.stopImmediatePropagation();
          window.OneTrust.ToggleInfoDisplay();
        };
      });
    });
  }
}

export default debounce(reloadOTSettingsButton);
